<template>
    <v-form v-model="valid">
        <v-row class="white-card">
            <v-col cols="12" class="mt-10">
                <v-img class="mx-auto" width="69" contain :src="imgLogo"/>
            </v-col>
            <v-col cols="12" class="headline-heavy text-center">
                Iniciar Sesión
            </v-col>
            <v-col cols="10" offset="1" md="8" offset-md="2">
                <kimsa-text-field
                    label="Email"
                    :rules="emailRules"
                    @change="email = $event"
                    :value="email"
                    outlined dense
                    inputMode="email"
                />
                <kimsa-password-field
                    label="Contraseña"
                    :rules="passwordRules"
                    @change="password = $event"
                    outlined dense
                    @enter="onLogin"
                    class="mt-5"
                />

                <div class="text-end mt-3">
                    <v-btn color="primary" text x-small depressed class="normal-btn" @click="showResetPassword">
                        ¿Olvidaste tu contraseña?
                    </v-btn>
                </div>

                <div class="text-center my-7">
                    <v-btn color="secondary" x-large depressed class="normal-btn"
                           :loading="loading" :disabled="!valid"
                           @click="onLogin">
                        Continuar
                    </v-btn>
                </div>

                <reset-password-dialog ref="reset"/>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>

import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaPasswordField from "@/components/common/inputs/KimsaPasswordField";
import {rules} from "@/utils/Rules";
import {mapActions} from "vuex";
import ResetPasswordDialog from "@/components/entrance/ResetPasswordDialog";

export default {
    name: "LoginCard",
    components: {
        ResetPasswordDialog,
        KimsaTextField,
        KimsaPasswordField,
    },
    data() {
        return {
            valid: false,
            email: '',
            password: '',
            showPassword: true,
            loading: false,
            emailRules: [
                rules.required,
                rules.email,
            ],
        }
    },
    computed: {
        passwordRules() {
            return [rules.required, rules.minLength(this.password, 6)]
        },
    },
    mounted() {
        const vm = this
        if (vm.$route.query.email) vm.email = vm.$route.query.email
    },
    methods: {
        ...mapActions({login: 'auth/login'}),
        async onLogin() {
            const vm = this
            vm.loading = true

            let response = await vm.login({email: vm.email, password: vm.password})
            // console.log('response login',response)
            if (response.data.error) {
                vm.loading = false
                return vm.toast('Datos incorrectos', 'error')
            }
            vm.loading = false
            vm.$emit('success')
        },
        goToRegisterClient() {
            const vm = this
            vm.$router.push({name: 'client.register'})
        },
        showResetPassword() {
            const vm = this
            vm.$refs.reset.show()
        }
    },
    watch: {
        '$route.query.email'(val) {
            if (val) this.email = val
        },
    }
}
</script>

<style scoped>

</style>
